/**
 * 6-letter words for RSTLNE game
 * Exact words from original project
 */

const words6: string[] = [
  "FABRIC", "DIMPLE", "ZENITH", "BEACON", "HOLLOW", "CAMERA", "OXYGEN", "ATTACK", "GUITAR", "IMPACT",
  "RUSTIC", "UPLIFT", "VELVET", "WANDER", "ORCHID", "MARKET", "JASPER", "GALAXY", "SACRED", "BLOUSE",
  "MYSTIC", "VIRTUE", "DINNER", "LIZARD", "MARBLE", "INSECT", "FOREST", "HAMMER", "TINKER", "JIGSAW",
  "FOSSIL", "HARBOR", "RARELY", "ZODIAC", "VISION", "HUNTER", "ICEBERG", "CASTLE", "FINGER", "MAGNET",
  "PLUNGE", "BANKER", "KETTLE", "TACKLE", "HYBRID", "BOTTLE", "TEMPLE", "SPRINT", "WALNUT", "ENIGMA",
  "JACKET", "GOBLIN", "LUXURY", "TICKET", "GOBLET", "WINDOW", "CIRCLE", "DANCER", "EARTHY", "SILVER",
  "RIBBON", "EXOTIC", "OBJECT", "FLAVOR", "CIPHER", "THRIVE", "PURPLE", "BASKET", "DESIRE", "CANVAS",
  "DILUTE", "BLAZER", "YELLOW", "GELATO", "CANDLE", "HUNGER", "RANGER", "ANCHOR", "CANYON", "URINAL",  "PENCIL",
  "WAFFLE", "FROZEN", "VENDOR", "IGNITE", "TRADER", "SIZZLE", "LEGEND", "NATURE", "ORIGIN", "MIRROR",
  "HANDLE", "KERNEL", "NICKEL", "GARDEN", "FRENZY", "BANANA", "VIOLET", "SINGER", "PLASMA", "TUNNEL",
  "YOGURT", "ISLAND", "SHADOW", "DOLLAR", "DAZZLE", "BORROW", "PATCHY", "JALOPY", "SUNSET", "INCITE",
  "BALLET", "EFFORT", "PLANET", "UNFOLD", "ENGINE", "TRAVEL", "RHYTHM", "TROPHY", "BREEZE", "ROCKET",
  "QUARTZ", "SHIELD", "NARROW", "PIRATE", "SPIRAL", "LAPTOP", "ARTIST", "JUNGLE", "KEEPER", "MANNER",
  "QUIVER", "FRIEND", "UPWARD", "COFFEE", "KITTEN", "ARCADE", "CITRUS", "TUNDRA", "BANNER", "VESSEL",
  "EVOLVE", "OUTLET", "NEEDLE", "HEAVEN", "STREAM", "MARKER", "EXPERT", "RIPPLE", "NUGGET", "APATHY",
  "ORANGE", "ZEALOT", "LIQUID", "DESERT", "DESIGN", "KARATE", "FOLDER", "LOCUST", "STRIDE", "LAUREL",
  "VORTEX", "GLANCE", "PEBBLE", "FROSTY", "URCHIN", "WICKER", "JOVIAL", "EMBLEM", "CASINO", "ALIGHT",
  "MUSEUM", "SHIVER", "SADDLE", "REVOLT", "UNTOLD", "YONDER", "CACTUS", "NAPKIN", "PARCEL",
  "WHIMSY", "NEBULA", "ORACLE", "SILENT", "SANDAL", "QUAINT", "ABROAD", "BEHALF", "CLAUSE", "DEBATE",
  "EMPIRE", "GARAGE", "HEADER", "INCOME", "JUNIOR", "LAWFUL", "MARINE", "NOTION", "OFFSET", "PANTRY",
  "QUARRY", "REASON", "SEASON", "UPBEAT", "WISDOM", "ZINGER", "ADJUST", "BRIDGE", "DEMAND", "GOSPEL",
  "HELMET", "IGNORE", "KNIGHT", "LEADER", "MEMBER", "OYSTER", "PICNIC", "RETAIL", "SHOVEL",
  "TRICEP", "VALLEY", "WINTER", "YANKEE", "ZIPPER", "ANYONE", "DEGREE", "EMBARK", "GRAVEL", "HAMPER",
  "INFLUX", "JOCKEY", "LUMBER", "NEPHEW", "ORIENT", "PROFIT", "RARITY", "SAMPLE", "UNLOCK", "VACANT",
  "WRENCH"
];

export default words6;
